import { useContext } from 'react';
import { Context as InCategorySearchPreviewsContext } from 'contexts/InCategorySearchPreviews';

const useInCategorySearchPreviews = () => {
    const { state, actions } =
        useContext(InCategorySearchPreviewsContext) || {};
    return [state, actions];
};

export default useInCategorySearchPreviews;
